export default __webpack_public_path__ + "static/media/nl.62f69d3c.svg";